import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SegOption } from '../segmented/payarc-segmented.component';
import { ThemeService } from '../../data/services/Theme/theme.service';

/** Quick icon toggle (compact) mirrors the prototype's topbar `.pa-theme-toggle` button:
 *  always sets an explicit light/dark, cycling off of the current effective theme.
 *  "System" stays reachable from the full Light/Dark/System control (compact=false). */
@Component({
  selector: 'payarc-theme-toggle',
  template: `
    <button *ngIf="compact" type="button" class="pa-theme-toggle-btn" aria-label="Toggle dark mode"
      title="Toggle dark mode" (click)="toggle()">
      <svg *ngIf="(effectiveDark$ | async) === false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>
      </svg>
      <svg *ngIf="effectiveDark$ | async" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="4"/>
        <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>
      </svg>
    </button>
    <payarc-segmented *ngIf="!compact"
      [options]="options"
      [value]="theme.theme$ | async"
      (valueChange)="theme.setTheme($event)">
    </payarc-segmented>`,
  styleUrls: ['./payarc-theme-toggle.component.css'],
  standalone: false
})
export class PayarcThemeToggleComponent {
  @Input() compact = false;

  options: SegOption[] = [
    { label: 'Light', value: 'light' },
    { label: 'Dark', value: 'dark' },
    { label: 'System', value: null },
  ];

  effectiveDark$: Observable<boolean> = this.theme.theme$.pipe(map(() => this.theme.effectiveDark()));

  constructor(public theme: ThemeService) {}

  toggle(): void {
    this.theme.toggle();
  }
}
